import {ThermalBackpackConditionEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function thermalBackpackConditionNameFilter(type: ThermalBackpackConditionEnum): string {
  switch(type) {
    case ThermalBackpackConditionEnum.New: return i18n.t(LF.New) as string;
    case ThermalBackpackConditionEnum.Used: return i18n.t(LF.Used) as string;

  }
}
